import { render } from "./App.vue?vue&type=template&id=7d220b2a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=7d220b2a&lang=css"
script.render = render

export default script